import { render, staticRenderFns } from "./ModalFormularioProgramaUniversidad.vue?vue&type=template&id=ecc7bc56&scoped=true"
import script from "./ModalFormularioProgramaUniversidad.vue?vue&type=script&lang=js"
export * from "./ModalFormularioProgramaUniversidad.vue?vue&type=script&lang=js"
import style0 from "./ModalFormularioProgramaUniversidad.vue?vue&type=style&index=0&id=ecc7bc56&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecc7bc56",
  null
  
)

export default component.exports